import React from 'react'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

const ColumnContent = ({items, alignment}) => {
  return (
    <section className={`column-content intro-block ${alignment}`}>
      <div className="intro-block__inner">
        <div className='intro-block__wrapper'>
          <Fade bottom distance='40px'>
            <div className='column-content__items'>
              { items.map((el, i) => (
                <div className="column-content__item" key={i}>
                  { el.title && <h4>{parse(el.title)}</h4> }
                  { el.content && <div>{parse(el.content)}</div> }
                </div>
              ))}
            </div>
          </Fade>
        </div>
      </div>
    </section>
  )
}

export default ColumnContent